import {
  Column,
  ColumnProps,
  ColumnFilterElementTemplateOptions,
} from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { TFunction } from 'i18next';
import { formatDateAndTime } from '@/utils/formatDate';
import { FilterMatchMode } from 'primereact/api';

import InputDateFilter from '@/components/InputDateFilter/InputDateFilter';

import {
  filterApplyTemplate,
  filterClearTemplate,
  inputTextTemplate,
} from '@/components/Table/Table';

import { Schedule } from '../../types';

export const tableColumns: ColumnProps[] = [
  {
    field: 'ultimoCambio',
    header: 'Fecha Modificación',
    filter: false,
    sortable: true,
    showFilterMenu: false,
    body: (rowData: Schedule) =>
      formatDateAndTime(rowData?.ultimoCambio ?? null),
  },
  {
    field: 'comienzoOperaciones',
    header: 'Inicio',
    filter: false,
    body: (rowData: Schedule) => formatDateAndTime(rowData.comienzoOperaciones),
    showFilterMenu: false,
    sortable: true,
  },
  {
    field: 'finOperaciones',
    header: 'Fin',
    body: (rowData: Schedule) => formatDateAndTime(rowData.finOperaciones),
  },
  {
    field: 'fechaFinDescarga',
    header: 'Entrega import',
    body: (rowData: Schedule) => formatDateAndTime(rowData.fechaFinDescarga),
  },
  {
    field: 'aperturaStacking',
    header: 'Apertura',
    body: (rowData: Schedule) => formatDateAndTime(rowData.aperturaStacking),
  },
  {
    field: 'cierreStacking',
    header: 'Cierre',
    body: (rowData: Schedule) => formatDateAndTime(rowData.cierreStacking),
  },
  {
    field: 'deadline',
    header: 'Ingreso tardío hasta',
    body: (rowData: Schedule) => formatDateAndTime(rowData.deadline ?? null),
  },
];

export const getHeaderColumnsGroup = (
  translates: TFunction<'schedule', undefined>
) => (
  <ColumnGroup>
    <Row>
      <Column
        header="Fecha Modificación"
        field="ultimoCambio"
        rowSpan={3}
        sortable
        showFilterMenu
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
    </Row>
    <Row>
      <Column
        field="comienzoOperaciones"
        header={translates('tableHeadings.operations')}
        colSpan={3}
      />
      <Column
        header={translates('tableHeadings.stacking')}
        colSpan={4}
        style={{ borderTopRightRadius: '16px' }}
      />
    </Row>
    <Row>
      <Column
        header={translates('tableHeadings.start')}
        field="comienzoOperaciones"
        sortable
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
        filterField="comienzoOperaciones"
      />
      <Column
        header={translates('tableHeadings.end')}
        field="finOperaciones"
        filterField="finOperaciones"
        sortable
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
      />
      <Column
        header={translates('tableHeadings.importDelivery')}
        field="fechaFinDescarga"
        filterField="fechaFinDescarga"
        sortable
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
        body={(rowData) =>
          rowData.fechaFinDescarga
            ? formatDateAndTime(rowData.fechaFinDescarga)
            : '-'
        }
      />
      <Column
        header={translates('tableHeadings.opening')}
        field="aperturaStacking"
        filterField="aperturaStacking"
        sortable
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
      />
      <Column
        header={translates('tableHeadings.closing')}
        field="cierreStacking"
        filterField="cierreStacking"
        sortable
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
      />
      <Column
        header={translates('tableHeadings.lateEntry')}
        field="deadline"
        filterField="deadline"
        sortable
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
      />
    </Row>
  </ColumnGroup>
);

export const tableFilters = {
  ultimoCambio: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  },
  comienzoOperaciones: { value: null, matchMode: FilterMatchMode.DATE_IS },
  finOperaciones: { value: null, matchMode: FilterMatchMode.DATE_IS },
  fechaFinDescarga: { value: null, matchMode: FilterMatchMode.DATE_IS },
  aperturaStacking: { value: null, matchMode: FilterMatchMode.DATE_IS },
  cierreStacking: { value: null, matchMode: FilterMatchMode.DATE_IS },
  deadline: { value: null, matchMode: FilterMatchMode.DATE_IS },
};
